/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheck from 'DesignSystem/Svgs/TysiaCheck/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/CustomResource/Content/Trigger"
  
}) {
let customResourceStatusTypeValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusType',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let customResourceStatusTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusType',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let customResourceStatusTypeValueData2 = fromData.useDataFormat({ viewPath,
context: 'custom_resource',
path: 'statusType',
format: fromHelpers.getColor,
})
let customResourceStatusTextValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusText',
})
let constantData = 'OFF_TRACK'
let aggregateData = fromAggregate.equals(customResourceStatusTextValueData, constantData)
let customResourceStatusTypeValueData3 = fromData.useDataFormat({ viewPath,
context: 'custom_resource',
path: 'statusType',
format: fromHelpers.getColor,
})
let customResourceStatusTextValueData1 = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusText',
})
let constantData1 = 'ON_TRACK'
let aggregateData1 = fromAggregate.equals(customResourceStatusTextValueData1, constantData1)
let customResourceStatusTextValueData2 = fromData.useDataFormat({ viewPath,
context: 'custom_resource',
path: 'statusText',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 cursor="pointer"
 data="custom_resource.statusType"
 type={customResourceStatusTypeValueData}
 style="filled"
 size="tiny"
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
 marginLeft={dtSpaceXxs}
 marginRight={2}
>
{childProps => (
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-HFmAS': customResourceStatusTypeValueData1,'--btlr-2-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btrr-3-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbrr-4-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-5-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--w-6-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-7-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={aggregateData}>
<TysiaIconClose
  viewPath={`${viewPath}/TysiaIconClose`}
 height={12}
 width={12}
 data="custom_resource.statusType"
 format="helpers.js getColor"
 fill={customResourceStatusTypeValueData2}
 data="custom_resource.statusText"
 data="'OFF_TRACK'"
 aggregate="/Data/aggregate.js equals"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData1}>
<TysiaCheck
  viewPath={`${viewPath}/TysiaCheck`}
 height={12}
 width={12}
 data="custom_resource.statusType"
 format="helpers.js getColor"
 fill2={customResourceStatusTypeValueData3}
 data="custom_resource.statusText"
 data="'ON_TRACK'"
 aggregate="/Data/aggregate.js equals"
/>
</fromFlow.When>
</div>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="custom_resource.statusText"
 marginLeft={2}
 format="helpers.js getText"
 text={customResourceStatusTextValueData2}
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}